import { notfound } from '@/asset/img'
import React from 'react'


const Notfound = () => {
    return (
        <div className='w-full h-full flex flex-col items-center justify-center text-center'>
            <img src={notfound} alt="Not Found" className='w-1/3 mb-6'/>
           <div>
             {/* <h5>Page Not Found</h5> */}
            <p>The page you are looking for either does not exist or <br/> you don't have permission to view it.</p>
          
           </div>
        </div>
    )
}

export default Notfound